<template>
	<div class="assets-value-graph-wrapper">
		<vue-chart type="line" :data="chartData" :options="options"/>
	</div>
</template>
<script>
import VueChart from "vue-chart-js";
import {formatPrice} from "../utils";
import {assetGraphPointsToChartData} from "@/store/helpers";

export default {
	name: "AssetsValueGraph",
	components: {
		VueChart
	},
	props: {
		points: {
			required: true
		}
	},
	watch: {
		points() {
			this.updateGraph(this.points);
		}
	},
	mounted() {
		this.updateGraph(this.points);
	},
	methods: {
		updateGraph(points) {
			const {labels, data} = assetGraphPointsToChartData(points);

			this.chartData.labels = labels;
			this.chartData.datasets[0].data = data;
		},
	},
	data() {
		return {
			chartData: {
				labels: [],
				datasets: [
					{
						borderColor: this.getGraphsCssVariables('__graph-line-color'),
						backgroundColor: "transparent",
						borderWidth: 2,
						data: [],
						pointBorderColor: "#fff",
						pointBackgroundColor: this.getGraphsCssVariables('__graph-line-color'),
						pointRadius: 0,
						pointHoverRadius: 6,
						pointHoverBorderWidth: 2,
						showLine: true
					}
				]
			},
			options: {
				responsive: true,
				maintainAspectRatio: false,
				title: {
					display: false
				},
				tooltips: {
					mode: "index",
					intersect: false,
					custom: function (tooltip) {
						if (!tooltip) {
							return;
						}
						tooltip.displayColors = false;
					},
					callbacks: {
						// use label callback to return the desired label
						label: function (tooltipItem, data) {
							return (
								tooltipItem.xLabel + ": " + formatPrice(tooltipItem.yLabel)
							);
						},
						// remove title
						title: function (tooltipItem, data) {
							return "";
						}
					}
				},
				legend: {
					display: false
				},
				hover: {
					mode: "index",
					intersect: false,
					animationDuration: 0
				},
				scales: {
					xAxes: [
						{
							display: true,
							scaleLabel: {
								display: true
							},
							gridLines: {
								drawOnChartArea: false,
								color: this.getGraphsCssVariables("__graph-border-color"),
								drawTicks: true,
								lineWidth: 1
							},
							ticks: {
								fontColor: this.getGraphsCssVariables("__graph-font-color"),
								display: true,
								maxTicksLimit: 15
							}
						}
					],
					yAxes: [
						{
							position: "right",
							display: true,
							scaleLabel: {
								display: true
							},
							gridLines: {
								drawOnChartArea: true,
								color: this.getGraphsCssVariables("__graph-border-color"),
								drawTicks: true,
								lineWidth: 1
							},
							ticks: {
								fontColor: this.getGraphsCssVariables("__graph-font-color"),
								maxTicksLimit: 4,
								display: true,
								callback: function (value, index, values) {
									return formatPrice(value, 2) + " EUR";
								}
							}
						}
					]
				},
				layout: {
					padding: {
						left: 0,
						right: 0,
						top: 0,
						bottom: 0
					}
				}
			}
		};
	}
};
</script>

<style lang="scss" scoped>
.assets-value-graph-wrapper {
	height: 270px;
}
</style>
